import React from "react";
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grow,
  Typography,
  Tooltip,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ReactCountryFlag from "react-country-flag";
import { AiOutlineGlobal } from "react-icons/ai";

// Mapping country names → ISO flag codes
const flagCodeMap = {
  India: "IN",
  UK: "GB",
  China: "CN",
  Dubai: "AE",
  Japan: "JP",
};

// Map countries to their scrap trading code
const scrapCodeMap = {
  Global: "LME",
  India: "MCX",
  UK: "LME",
  China: "SHFE",
  Dubai: "DFM",
  Japan: "TOCOM",
};

const CountrySelector = ({
  country,
  setCountry,
  currencyMap,
  unitMap,
  unit,
  setUnit,
}) => {
  const theme = useTheme();

  // console.log("CountrySelector render", country);

  return (
    <Grow in timeout={1000}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          mb: 4,
        }}
      >
        {/* Row for the two selectors */}
        <Box sx={{ display: "flex", gap: 3 }}>
          {/* Country selector + Scrap Trading Code label in a column */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {/* <FormControl
              sx={{
                minWidth: 200,
                "& .MuiOutlinedInput-root": {
                  borderRadius: 3,
                  backgroundColor: "background.paper",
                  boxShadow: theme.shadows[2],
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#4A90E2",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#9013FE",
                },
              }}
            >
              <InputLabel>Select Country</InputLabel>
              <Select
                value={country}
                label="Select Country"
                onChange={(e) => setCountry(e.target.value)}
              >
                <MenuItem value="Global">
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <AiOutlineGlobal /> Global
                  </Box>
                </MenuItem>
                {Object.keys(currencyMap).map((c) => (
                  <MenuItem key={c} value={c}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <ReactCountryFlag
                        countryCode={flagCodeMap[c]}
                        svg
                        style={{ width: "20px", height: "15px" }}
                      />
                      {c}
                    </Box>
                  </MenuItem>
                ))}
              </Select>
            </FormControl> */}

          
            <FormControl
            sx={{
              minWidth: 200,
              "& .MuiOutlinedInput-root": {
                borderRadius: 3,
                backgroundColor: "background.paper",
                boxShadow: theme.shadows[2],
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#4A90E2", // initial border color
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#9013FE", // border color on focus
              },
            }}
          >
            <InputLabel>Select Country</InputLabel>
            <Select
              value={country}
              label="Select Country"
              onChange={(e) => setCountry(e.target.value)}
            >
              <MenuItem value="Global">
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <AiOutlineGlobal /> Global
                </Box>
              </MenuItem>
              <MenuItem value="UK">
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <ReactCountryFlag
                    countryCode="GB"
                    svg
                    style={{ width: "20px", height: "15px" }}
                  />
                  UK
                </Box>
              </MenuItem>
              <MenuItem value="China">
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <ReactCountryFlag
                    countryCode="CN"
                    svg
                    style={{ width: "20px", height: "15px" }}
                  />
                  China
                </Box>
              </MenuItem>
              <MenuItem value="Dubai">
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <ReactCountryFlag
                    countryCode="AE"
                    svg
                    style={{ width: "20px", height: "15px" }}
                  />
                  Dubai
                </Box>
              </MenuItem>
              <MenuItem value="Japan">
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <ReactCountryFlag
                    countryCode="JP"
                    svg
                    style={{ width: "20px", height: "15px" }}
                  />
                  Japan
                </Box>
              </MenuItem>

                <MenuItem value="India">
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <ReactCountryFlag
                    countryCode="IN"
                    svg
                    style={{ width: "20px", height: "15px" }}
                  />
                  India
                </Box>
              </MenuItem>
            </Select>
          </FormControl>

            {/* Scrap Trading Code Label below country selector */}
            <Tooltip title="Scrap Trading Code" arrow placement="bottom">
              <Box
                sx={{
                  px: 2,
                  py: 0.5,
                  borderRadius: "0 0 8px 8px",
                  background:
                    "linear-gradient(90deg, #4A90E2 0%, #9013FE 100%)",
                  color: "#FFFFFF",
                  minWidth: 160,
                  textAlign: "center",
                  fontWeight: 600,
                  boxShadow: theme.shadows[2],
                  borderLeft: "1px solid #3B7AC1",
                  borderRight: "1px solid #3B7AC1",
                  borderBottom: "1px solid #3B7AC1",
                  position: "relative",
                  top: -1,
                  cursor: "help",
                  // mt: 1, 
                }}
              >
                {scrapCodeMap[country] || "-"}
              </Box>
            </Tooltip>
          </Box>

          {/* Unit selector */}
          <FormControl
            sx={{
              minWidth: 200,
              "& .MuiOutlinedInput-root": {
                borderRadius: 3,
                backgroundColor: "background.paper",
                boxShadow: theme.shadows[2],
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#4A90E2",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#9013FE",
              },
            }}
          >
            <InputLabel>Select Unit</InputLabel>
            <Select
              value={unit}
              label="Select Unit"
              onChange={(e) => setUnit(e.target.value)}
            >
              {unitMap.map(({ label, value }) => (
                <MenuItem key={value} value={value}>
                  {label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Box>
    </Grow>
  );
};

export default CountrySelector;
